// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/metallist/stylesheet/style.scss
 ** module id = 418
 ** module chunks = 1
 **/